import React, { Component } from "react";
import "./common.css";
import * as EmailValidator from "email-validator";
import Grid from "@mui/material/Grid";
import ClipLoader from "react-spinners/ClipLoader";
import { connect } from "react-redux";
import { signUpBegin } from "../actions/signupactions";
import { moveToLoginPage } from "../actions/routeactions";
import CreatePassword from "./CreatePassword";
import SecurityQuestion, { securityQuestions } from "./SecurityQuestion";
import { reportError } from "../actions/erroractions";

class SignUp extends Component {
  state = {
    email: "",
    password: "",
    securityQuestion: securityQuestions[0],
    securityAnswer: "",
  };

  constructor(props) {
    super(props);
    this.signUp = this.signUp.bind(this);
    this.updateUsername = this.updateEmail.bind(this);
    this.updatePassword = this.updatePassword.bind(this);
    this.updateEmail = this.updateEmail.bind(this);
    this.updateQuestion = this.updateQuestion.bind(this);
    this.updateAnswer = this.updateAnswer.bind(this);
    this.renderSignupButtons = this.renderSignupButtons.bind(this);
    this.renderSpinner = this.renderSpinner.bind(this);
    this.backToLogin = this.backToLogin.bind(this);
  }

  signUp() {
    const { email, password, securityQuestion, securityAnswer } = this.state;
    const { dispatch } = this.props;

    let errorMsg;
    if ((errorMsg = this.validateSignUpDetails()) == null) {
      dispatch(signUpBegin(email, password, securityQuestion, securityAnswer));
    } else {
      dispatch(reportError(errorMsg));
    }
  }

  validateSignUpDetails() {
    const { email, password } = this.state;

    const isValid = EmailValidator.validate(email);

    if (!isValid) {
      return "Invalid email";
    } else {
      const pswMsg = this.validatePassword(password);

      return pswMsg;
    }
  }

  validateEmail() {}

  validatePassword(password) {
    if (password === "") {
      return "Password is empty.";
    }

    let capLetters = 0;
    let lowerCase = 0;
    let numbers = 0;

    for (let t = 0; t < password.length; t++) {
      if (password[t] >= "a" && password[t] <= "z") {
        lowerCase++;
      } else if (password[t] >= "A" && password[t] <= "Z") {
        capLetters++;
      } else if (password[t] >= "1" && password[t] <= "9") {
        numbers++;
      }
    }

    if (capLetters === 0) {
      return "Password needs at least one capitalized letter.";
    }

    if (lowerCase === 0) {
      return "Password needs at least one lowercase letter.";
    }

    if (numbers === 0) {
      return "Password needs at least one numerical letter.";
    }

    return null;
  }

  updateQuestion(e) {
    this.setState({
      securityQuestion: e.target.value,
    });
  }

  updateAnswer(e) {
    this.setState({
      securityAnswer: e.target.value,
    });
  }

  updatePassword(e) {
    this.setState({
      password: e.target.value,
    });
  }

  updateEmail(e) {
    this.setState({
      email: e.target.value,
    });
  }

  backToLogin() {
    const { dispatch } = this.props;
    dispatch(moveToLoginPage());
  }

  renderSignupButtons() {
    return (
      <React.Fragment>
        <Grid item xs={12}>
          <div>
            <button className="bbe-button" onClick={this.signUp}>
              Sign Up
            </button>
          </div>
        </Grid>
        <Grid item xs={12}>
          <p className="hyperlink" onClick={this.backToLogin}>
            <u>Already have an account</u>
          </p>
        </Grid>
      </React.Fragment>
    );
  }

  renderSpinner() {
    return (
      <Grid item xs={12}>
        <ClipLoader
          color="#FFFFFF"
          sizeUnit={"%"}
          size={100}
          loading={this.state.loading}
        />
      </Grid>
    );
  }

  render() {
    const { loading, signUpError } = this.props;

    return (
      <Grid container alignItems="center" justifyContent="center">
        <div className="form signup_form">
          <Grid item xs={12}>
            <h1>Sign Up</h1>
          </Grid>
          <Grid item xs={12}>
            <h4 className="label">Email</h4>
          </Grid>
          <Grid item xs={12}>
            <input
              type="text"
              className="textbox logintext"
              onChange={this.updateEmail}
            />
          </Grid>
          <Grid item xs={12}>
            <h4 className="label">Password</h4>
          </Grid>
          <CreatePassword updatePassword={this.updatePassword} />
          <Grid item xs={12}>
            <h4 className="label">Security Question</h4>
          </Grid>
          <Grid item xs={12}>
            <SecurityQuestion
              setQuestion={this.updateQuestion}
              setAnswer={this.updateAnswer}
            />
          </Grid>
          <Grid item xs={12}>
            <p className="error_message">{signUpError}</p>
          </Grid>
          {loading ? this.renderSpinner() : this.renderSignupButtons()}
        </div>
      </Grid>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.signup.loading,
  signUpError: state.signup.signUpError,
});

export default connect(mapStateToProps)(SignUp);
